import z from "zod";

export const offloadingFormSchema = z.object({
  enabledAutomaticDispatchPrivateNetwork: z.boolean(),
  enabledAutomaticDispatchPublicNetwork: z.boolean(),
  dispatchAutoPublicNetworkTime: z.string().min(1, "Field is required and can't be empty."),
  dispatchAutoPublicNetworkTimeframe: z.string(),
  dispatchPrivateNetworkTier1Time: z.string().min(1, "Field is required and can't be empty."),
  dispatchPrivateNetworkTier1Timeframe: z.string(),
  dispatchPrivateNetworkTier2Time: z.string().min(1, "Field is required and can't be empty."),
  dispatchPrivateNetworkTier2Timeframe: z.string(),
  dispatchPrivateNetworkTier3Time: z.string().min(1, "Field is required and can't be empty."),
  dispatchPrivateNetworkTier3Timeframe: z.string(),
});
